<template>
  <v-dialog persistent :value="deletePopup" width="800">

    <v-card color="primary" class="elevation-0 text-xs-left">
      <v-card-title class="px-4 py-2">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <h2 class="py-3 font-weight-regular primary text-uppercase white--text">ARE YOU SURE?</h2>
          </v-flex>
        </v-layout>
      </v-card-title>
    </v-card>

    <v-card class="elevation-0 pt-4 pb-5">

      <h2 class="font-weight-bold mb-4 heading-with-border relative pb-3">Are you sure want to remove {{ deleteObj.name }}?</h2>
      <div class="pb-3 text-xs-right px-4">
        <v-btn
        depressed
        @click="closeModal()"
        fab 
        color="primary"
        :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-2' : 'ml-2'"
        >
          <v-icon dark>close</v-icon>
        </v-btn>
        <v-btn
          depressed
          @click="deleteItem()"
          fab 
          color="primary"
          :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
        >
          <v-icon dark >check</v-icon>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';
import { some, isEmpty } from 'lodash';

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      roleList: 'role/list',
      deletePopup: 'role/delete',
      deleteObj: 'role/deleteObj',
    }),
  },

  created() {
    this.closeModal();
  },

  methods: {
   
    closeModal() {
      this.setDelete(false);
      this.setDeleteObj({});
    },

    /**
     * Delete Item
     */
    deleteItem() {
      this.spinner(true);
      const url = `${Env.url}/api/v1/roles/${ this.deleteObj.id }/`;
      AuthApi.deleteApi(url)
        .then((res) => {
          this.spinner(false);
          let newList = this.roleList.filter(item => item.id != this.deleteObj.id);
          this.setList(newList);
          this.snackbar({
            text: res.data.msg,
            timeout: 4000,
            open: true,
          });
          this.closeModal();
        })
        .catch((err) => {
          this.spinner(false);
          this.snackbar({
            text: 'Please try again later.',
            timeout: 4000,
            open: true,
          });
        });

    },
    ...mapActions({
      setDelete: 'role/setDelete',
      setDeleteObj: 'role/setDeleteObj',
      setList: 'role/setList',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>


